import { getPointTypeIconUrl } from "../logics/garbageCollectionPoints";

interface IPointType {
  pointType: string;
}

export const PointType = ({ pointType }: IPointType) => {
  return (
    <div className="route-panel__point-type">
      <img
        className="route-panel__point-type-image"
        src={getPointTypeIconUrl(pointType) || ""}
        alt="Не удалось загрузить иконку"
      />
      <p className="route-panel__point-type-name">{pointType}</p>
    </div>
  );
};
